import * as React from 'react';

import SidePanelItemGeneric from './SidePanelItemGeneric';
import SidePanelItemLink from './SidePanelItemLink';
import SidePanelItemCancelOffer from './SidePanelItemCancelOffer';
import SidePanelItemLists from './SidePanelItemLists';
import SidePanelItemInfluencerDetails from './SidePanelItemInfluencerDetails';

import type { SidePanelItem as SidePanelItemType } from 'types';

type Props = {
  item: SidePanelItemType
};

const SidePanelItem = (
  {
    item
  }: Props
): JSX.Element => {
  switch (item.type) {
    case 'lists':
      return (<SidePanelItemLists item={item} />);
    case 'cancel_offer':
      return (<SidePanelItemCancelOffer item={item} />);
    case 'link':
      return <SidePanelItemLink item={item} />;
    case 'shipping_address':
    case 'phone_number':
    case 'business_details':
    case 'bank_details':
      return <SidePanelItemInfluencerDetails item={item} />;
    default:
      return <SidePanelItemGeneric item={item} />;
  }
};

export default SidePanelItem;
